import { useState } from "react";
import { WidgetDisplay } from "./widget/components/WidgetDisplay";
import type { WidgetConfig, Message, AgentConfig } from "./shared/types";

import "./widget/index.css";

export default function App() {
  // Mock widget configuration
  const widgetConfig: WidgetConfig = {
    agentId: "demo-agent-123",
    apiUrl: "https://api.example.com",
    sourceUrl: "https://example.com",
    organizationId: "demo-org-456",
    disableSendMessage: false,
  };

  // Mock agent configuration
  const agentConfig: AgentConfig = {
    agentTitle: "Demo Assistant",
    name: "Demo Assistant",
    subheading: "How can I help you today?",
    subtitle: "Available 24/7",
    iconUrl: undefined,
    primaryColor: "#CC0020",
    welcomeMessage: "Hello! How can I assist you?",
    footerText: "Powered by AI",
    organizationId: "demo-org-456",
  };

  // Mock conversation state
  const [messages, setMessages] = useState<Message[]>([
    {
      id: "welcome-message",
      role: "assistant",
      content: agentConfig.welcomeMessage || "Welcome to the chat!",
      timestamp: Date.now(),
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [conversationId, setConversationId] = useState<string | null>(null);

  // Mock send message handler
  const handleSendMessage = async (content: string) => {
    setIsLoading(true);
    const userMessage: Message = {
      id: Date.now().toString(),
      role: "user",
      content,
      timestamp: Date.now(),
    };
    setMessages((prev) => [...prev, userMessage]);

    // Simulate API delay
    setTimeout(() => {
      const assistantMessage: Message = {
        id: (Date.now() + 1).toString(),
        role: "assistant",
        content:
          "This is a demo response. Connect to a real API for actual responses.",
        timestamp: Date.now(),
      };
      setMessages((prev) => [...prev, assistantMessage]);
      setIsLoading(false);
    }, 1000);
  };

  // Mock retry message handler
  const handleRetryMessage = async (messageId: string) => {
    console.log("Retry message:", messageId);
  };

  // Mock close handler
  const handleClose = () => {
    console.log("Widget closed");
  };

  // Mock reset handler
  const handleReset = () => {
    console.log("Resetting conversation");
    setConversationId(null);
    setMessages([
      {
        id: "welcome-message",
        role: "assistant",
        content: agentConfig.welcomeMessage || "Welcome to the chat!",
        timestamp: Date.now(),
      },
    ]);
  };

  return (
    <main className="min-h-screen flex items-center justify-center bg-gray-100">
      <section className="w-full max-w-md h-[600px]">
        <WidgetDisplay
          widgetConfig={widgetConfig}
          agentConfig={agentConfig}
          messages={messages}
          isLoading={isLoading}
          conversationId={conversationId}
          statusMessage={null}
          onSendMessage={handleSendMessage}
          onRetryMessage={handleRetryMessage}
          onClose={handleClose}
          onReset={handleReset}
        />
      </section>
    </main>
  );
}
